import { SerializedVector3 } from "../types";

const serializeVector3 = (vector): SerializedVector3 => {
    return { x: vector._x, y: vector._y, z: vector._z };
};

export default serializeVector3